/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, styled } from '@ethings/ui-toolkit';
import { PaginationItem } from '@mui/material';
import { FC, useMemo, type JSX } from 'react';
import { useSmallScreen } from '../../hooks';
import { testid } from '../../util';
import { Layout } from './layout';
import { Props } from './types';

const StyledPagination = styled(Pagination)(({ theme }) => ({
  marginBottom: theme.spacing(-1.25),
}));

export const DialogListView: FC<Props> = (props): JSX.Element => {
  const smallScreen = useSmallScreen();

  const {
    isLoading,
    limit,
    listContent,
    matchCount,
    pagination,
    search,
    setPagination,
    title,
    subtitle,
  } = props;

  const paginationComponent = useMemo(
    () => limit && matchCount > limit
      ? <StyledPagination
        count={Math.ceil(matchCount / limit)}
        disabled={isLoading}
        onChange={(_, page) => setPagination({ limit, skip: limit * (page - 1) })}
        renderItem={(item) => (
          <PaginationItem data-testid={testid`pagination-item-${item.type}${item.type === 'page' ? `-${item.page ?? ''}` : ''}`}
            {...item}
          />
        )}
        page={Math.floor(pagination.skip / limit) + 1}
        showFirstButton={!smallScreen}
        showLastButton={!smallScreen}
        size={smallScreen ? 'small' : 'small'}
      />
      : undefined,
    [isLoading, matchCount, pagination, smallScreen],
  );

  return (
    <Layout
      data-testid={props['data-testid']}
      listContent={listContent}
      paginationComponent={paginationComponent}
      search={search}
      title={title}
      subtitle={subtitle}
    />
  );
};
